import { render, staticRenderFns } from "./CoinInput.vue?vue&type=template&id=6a369fe6&scoped=true"
import script from "./CoinInput.vue?vue&type=script&lang=js"
export * from "./CoinInput.vue?vue&type=script&lang=js"
import style0 from "./CoinInput.vue?vue&type=style&index=0&id=6a369fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a369fe6",
  null
  
)

export default component.exports